module.exports = __webpack_public_path__ + "img/rent.619adecc.svg";